import React, { useState } from 'react';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';
import {
  Container,
  Button,
  Spinner,
  Accordion,
  Card,
  Form,
  Table,
  Row,
  Col,
  Pagination,
} from 'react-bootstrap';
import Header from '~/Components/Header/Header';
import { FaSearch } from 'react-icons/fa';
import moment from 'moment';
import { useEffect } from 'react';
import Ocorrencia from '~/Components/Proposta/Ocorrencia';
import {
  CARACTERISTICA_ESTORNA_PROPOSTA,
  CARACTERISTICA_HOMOLOGADOR,
  PROSPECTO_STATUS_ENUM,
} from '~/constant';
import Select from 'react-select';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import AuthStorage from '~/Utils/AuthStorage';

const ITENS_POR_PAGINA_BUSCA_DIRETA = 20;
const MAX_PAGINAS_BUSCA_DIRETA = 5;

export default function PropostaEstorno() {
  const [propostas, setPropostas] = useState([]);
  const [propostasFiltro, setPropostasFiltro] = useState([]);
  const [filtroProposta, setFiltroProposta] = useState('');
  const [exibeDetalhes, setExibeDetalhes] = useState(null);
  const [confirmaEstorno, setConfirmaEstorno] = useState(null);
  const [exibeListaOcorrencia, setExibeListaOcorrencia] = useState(null);
  const [exibeDetalheOcorrencia, setExibeDetalheOcorrencia] = useState(null);
  const [revalidaTicket, setRevalidaTicket] = useState(null);
  const [justificativa, setJustificativa] = useState('');
  const [estornandoProposta, setEstornandoProposta] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // W-0556 — Busca direta admin (UEstorno_de_Propostas.pas)
  const [filtroDataIni, setFiltroDataIni] = useState('');
  const [filtroDataFim, setFiltroDataFim] = useState('');
  const [filtroGe, setFiltroGe] = useState(null);
  const [opcoesGe, setOpcoesGe] = useState([]);
  const [carregandoGe, setCarregandoGe] = useState(false);
  const [filtroNumeroProposta, setFiltroNumeroProposta] = useState('');
  const [resultadosBusca, setResultadosBusca] = useState([]);
  const [buscando, setBuscando] = useState(false);
  const [
    propostasSelecionadasDireta,
    setPropostasSelecionadasDireta,
  ] = useState([]);
  const [justificativaDireta, setJustificativaDireta] = useState('');
  const [estornandoDireta, setEstornandoDireta] = useState(false);
  const [paginaBuscaDireta, setPaginaBuscaDireta] = useState(1);
  const possuiPermissaoBuscaDireta =
    !!AuthStorage &&
    AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
    AuthStorage.temCaracteristica(CARACTERISTICA_ESTORNA_PROPOSTA);
  const totalPaginasBuscaDireta = Math.max(
    1,
    Math.ceil(resultadosBusca.length / ITENS_POR_PAGINA_BUSCA_DIRETA)
  );
  const paginaBuscaDiretaSegura = Math.min(
    paginaBuscaDireta,
    totalPaginasBuscaDireta
  );
  const inicioBuscaDireta =
    (paginaBuscaDiretaSegura - 1) * ITENS_POR_PAGINA_BUSCA_DIRETA;
  const fimBuscaDireta = Math.min(
    inicioBuscaDireta + ITENS_POR_PAGINA_BUSCA_DIRETA,
    resultadosBusca.length
  );
  const resultadosBuscaPagina = resultadosBusca.slice(
    inicioBuscaDireta,
    fimBuscaDireta
  );

  const mudarPaginaBuscaDireta = pagina => {
    const proximaPagina = Math.max(
      1,
      Math.min(pagina, totalPaginasBuscaDireta)
    );
    setPaginaBuscaDireta(proximaPagina);
  };

  const limparBuscaDireta = () => {
    setPropostasSelecionadasDireta([]);
    setJustificativaDireta('');
  };

  const toggleSelecionarDireta = codigoProposta => {
    setPropostasSelecionadasDireta(prev =>
      prev.includes(codigoProposta)
        ? prev.filter(codigo => codigo !== codigoProposta)
        : [...prev, codigoProposta]
    );
  };

  const toggleSelecionarTodasDireta = () => {
    if (propostasSelecionadasDireta.length === resultadosBusca.length) {
      setPropostasSelecionadasDireta([]);
      return;
    }

    setPropostasSelecionadasDireta(
      resultadosBusca.map(item => item.codigo_proposta)
    );
  };

  const handleBuscarDireta = async () => {
    const params = {};
    if (filtroDataIni) params.dataIni = filtroDataIni;
    if (filtroDataFim) params.dataFim = filtroDataFim;
    if (filtroGe) params.codigoGrupoEmpresa = filtroGe.value;
    if (filtroNumeroProposta)
      params.numeroProposta = Number(filtroNumeroProposta);

    if (Object.keys(params).length === 0) {
      toast.warn('Informe ao menos um filtro para buscar.', {
        position: 'top-right',
      });
      return;
    }

    setBuscando(true);
    limparBuscaDireta();
    setPaginaBuscaDireta(1);
    try {
      const resposta = await api.buscarPropostasParaEstorno(params);
      setResultadosBusca(Array.isArray(resposta) ? resposta : []);
      if (!resposta || resposta.length === 0) {
        toast.info('Nenhuma proposta efetivada encontrada.', {
          position: 'top-right',
        });
      }
    } catch (err) {
      const msg =
        err && err.message ? err.message : 'Erro ao buscar propostas.';
      toast.error(msg, { position: 'top-right' });
      setResultadosBusca([]);
      setPaginaBuscaDireta(1);
    }
    setBuscando(false);
  };

  const handleEstornarDireta = async () => {
    const codigosSelecionados =
      propostasSelecionadasDireta.length > 0 ? propostasSelecionadasDireta : [];

    if (codigosSelecionados.length === 0) {
      toast.warn('Selecione ao menos uma proposta.', {
        position: 'top-right',
      });
      return;
    }

    if (justificativaDireta.length < 11) {
      toast.warn('Justificativa precisa ter ao menos 11 caracteres.', {
        position: 'top-right',
      });
      return;
    }

    setEstornandoDireta(true);
    try {
      await api.estornarPropostaAdmin({
        proposta: codigosSelecionados[0],
        propostas: codigosSelecionados,
        justificativa: justificativaDireta,
        revalida_ticket: true,
      });

      toast.success('Proposta(s) estornada(s) com sucesso.', {
        position: 'top-right',
      });
      setResultadosBusca(prev =>
        prev.filter(p => !codigosSelecionados.includes(p.codigo_proposta))
      );
      limparBuscaDireta();
    } catch (err) {
      const msg =
        err && err.message ? err.message : 'Erro ao estornar proposta.';
      toast.error(msg, { position: 'top-right' });
    }
    setEstornandoDireta(false);
  };

  const formatarData = valor => {
    if (!valor) return '';
    const m = moment(valor);
    return m.isValid() ? m.format('DD/MM/YYYY') : '';
  };

  const formatarMoeda = valor => {
    if (valor == null) return '';
    return Number(valor).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  };

  const renderPaginacaoBuscaDireta = () => {
    if (resultadosBusca.length <= ITENS_POR_PAGINA_BUSCA_DIRETA) return null;

    const metadePaginas = Math.floor(MAX_PAGINAS_BUSCA_DIRETA / 2);
    const inicioPaginas = Math.max(1, paginaBuscaDiretaSegura - metadePaginas);
    const fimPaginas = Math.min(
      totalPaginasBuscaDireta,
      inicioPaginas + MAX_PAGINAS_BUSCA_DIRETA - 1
    );
    const inicioPaginasAjustado = Math.max(
      1,
      fimPaginas - MAX_PAGINAS_BUSCA_DIRETA + 1
    );
    const itensPaginacao = [
      <Pagination.First
        key="first"
        disabled={paginaBuscaDiretaSegura === 1}
        onClick={() => mudarPaginaBuscaDireta(1)}
      />,
      <Pagination.Prev
        key="prev"
        disabled={paginaBuscaDiretaSegura === 1}
        onClick={() => mudarPaginaBuscaDireta(paginaBuscaDiretaSegura - 1)}
      />,
    ];

    if (inicioPaginasAjustado > 1) {
      itensPaginacao.push(
        <Pagination.Ellipsis key="ellipsis-start" disabled />
      );
    }

    for (
      let pagina = inicioPaginasAjustado;
      pagina <= fimPaginas;
      pagina += 1
    ) {
      itensPaginacao.push(
        <Pagination.Item
          key={`pagina-${pagina}`}
          active={pagina === paginaBuscaDiretaSegura}
          onClick={() => mudarPaginaBuscaDireta(pagina)}
        >
          {pagina}
        </Pagination.Item>
      );
    }

    if (fimPaginas < totalPaginasBuscaDireta) {
      itensPaginacao.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
    }

    itensPaginacao.push(
      <Pagination.Next
        key="next"
        disabled={paginaBuscaDiretaSegura === totalPaginasBuscaDireta}
        onClick={() => mudarPaginaBuscaDireta(paginaBuscaDiretaSegura + 1)}
      />,
      <Pagination.Last
        key="last"
        disabled={paginaBuscaDiretaSegura === totalPaginasBuscaDireta}
        onClick={() => mudarPaginaBuscaDireta(totalPaginasBuscaDireta)}
      />
    );

    return (
      <div className="d-flex flex-wrap align-items-center justify-content-between mt-2">
        <small className="text-muted mb-2 mb-md-0">
          Mostrando {inicioBuscaDireta + 1} até {fimBuscaDireta} de{' '}
          {resultadosBusca.length} proposta(s)
        </small>
        <Pagination size="sm" className="mb-0 flex-wrap">
          {itensPaginacao}
        </Pagination>
      </div>
    );
  };

  const estornarProposta = async proposta => {
    const request = {
      proposta,
      revalida_ticket: !!revalidaTicket,
      justificativa,
    };
    setEstornandoProposta(true);

    const propostaSelecionada =
      propostas && propostas.find(p => p.proposta === proposta);

    try {
      const response = await api.estornarProposta(request);
      if (response) {
        toast.success(response.message, {
          position: 'top-right',
        });
        if (propostaSelecionada) {
          const prospectoEtapa = await api.consultarEtapaAtualProspecto(
            propostaSelecionada.codigo_prospecto
          );

          const alterado = await api.atualizarEtapaProspecto({
            codigo_prospecto: propostaSelecionada.codigo_prospecto,
            etapa_atual: prospectoEtapa.codigo_etapa,
            nova_etapa: PROSPECTO_STATUS_ENUM.em_atendimento,
            codigo_familia: propostaSelecionada.codigo_familia,
          });

          if (alterado) {
            toast.success('Prospecto atualizado com sucesso', {
              position: 'top-right',
            });
          }
        }
      }
      getPropostas();
    } catch ({ message }) {
      toast.error(message, {
        position: 'top-right',
      });
    }
    setEstornandoProposta(false);
  };

  const toggleExibirDetalhes = ({ proposta, justificativa }) => {
    setExibeListaOcorrencia(null);
    setExibeDetalheOcorrencia(null);
    setConfirmaEstorno(null);
    setRevalidaTicket(null);
    setJustificativa('');

    if (proposta === exibeDetalhes) setExibeDetalhes(null);
    else {
      setExibeDetalhes(proposta);
      setJustificativa(justificativa);
    }
  };

  const toggleExibirDetalhesOcorrencia = codigo => {
    if (codigo === exibeDetalheOcorrencia) setExibeDetalheOcorrencia(null);
    else setExibeDetalheOcorrencia(codigo);
  };

  const getPropostas = async () => {
    setIsLoading(true);
    let novasPropostas = await api.getSolicitacoesDeEstornoProposta();
    setPropostas(novasPropostas);
    setPropostasFiltro(novasPropostas);
    setIsLoading(false);
  };

  const carregarGruposEmpresa = async () => {
    setCarregandoGe(true);
    try {
      const grupos = await api.buscarGruposEmpresaEstorno();
      setOpcoesGe(
        (Array.isArray(grupos) ? grupos : []).map(item => ({
          value: item.codigo_grupo_empresa,
          label: `${item.codigo_grupo_empresa} - ${item.apelido}`,
        }))
      );
    } catch ({ message }) {
      toast.error(message || 'Erro ao buscar grupos de empresa.', {
        position: 'top-right',
      });
    }
    setCarregandoGe(false);
  };

  useEffect(() => {
    getPropostas();
    if (possuiPermissaoBuscaDireta) {
      carregarGruposEmpresa();
    }
  }, [possuiPermissaoBuscaDireta]);

  useEffect(() => {
    if (paginaBuscaDireta > totalPaginasBuscaDireta) {
      setPaginaBuscaDireta(totalPaginasBuscaDireta);
    }
  }, [paginaBuscaDireta, totalPaginasBuscaDireta]);

  useEffect(() => {
    const listaFiltrada = propostas.filter(item =>
      item.proposta.toString().includes(filtroProposta)
    );
    setPropostasFiltro(listaFiltrada);
  }, [filtroProposta]);

  const getColorStyle = ({ proposta = 0, cor = '' }) => {
    let selectoStyle = `.proposta-${proposta}::before{ border-left-color: ${cor} }`;
    return <style dangerouslySetInnerHTML={{ __html: selectoStyle }}></style>;
  };

  return (
    <div>
      <Header title="Estorno de Proposta" />

      {possuiPermissaoBuscaDireta && (
        <Container fluid className="mt-3 px-3">
          <Accordion defaultActiveKey="0">
            <Card className="w-100">
              <Accordion.Toggle
                as={Card.Header}
                eventKey="0"
                style={{ cursor: 'pointer' }}
              >
                <strong>Busca Direta (Admin)</strong>
                <small className="text-muted ml-2">
                  Pesquisar propostas efetivadas por data, GE ou número
                </small>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  <Row>
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label className="small mb-1">
                          Data Efetivação Inicial
                        </Form.Label>
                        <Form.Control
                          type="date"
                          value={filtroDataIni}
                          onChange={e => setFiltroDataIni(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label className="small mb-1">
                          Data Efetivação Final
                        </Form.Label>
                        <Form.Control
                          type="date"
                          value={filtroDataFim}
                          onChange={e => setFiltroDataFim(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group>
                        <Form.Label className="small mb-1">GE</Form.Label>
                        <Select
                          value={filtroGe}
                          onChange={setFiltroGe}
                          options={opcoesGe}
                          styles={customStyles}
                          components={{ DropdownIndicator }}
                          isClearable
                          isLoading={carregandoGe}
                          placeholder="Selecione"
                          noOptionsMessage={() => 'Nenhum GE encontrado'}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group>
                        <Form.Label className="small mb-1">
                          Nº Proposta
                        </Form.Label>
                        <Form.Control
                          type="number"
                          value={filtroNumeroProposta}
                          onChange={e =>
                            setFiltroNumeroProposta(e.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col md={2} className="d-flex align-items-end">
                      <Form.Group className="w-100">
                        <Button
                          variant="primary"
                          block
                          onClick={handleBuscarDireta}
                          disabled={buscando}
                        >
                          {buscando ? (
                            <Spinner animation="border" size="sm" />
                          ) : (
                            <>
                              <FaSearch className="mr-1" /> Buscar
                            </>
                          )}
                        </Button>
                      </Form.Group>
                    </Col>
                  </Row>

                  {resultadosBusca.length > 0 && (
                    <>
                      <div className="text-muted small mb-2">
                        {resultadosBusca.length} proposta(s) encontrada(s).
                        Limite de 200 por busca.
                      </div>
                      <div className="w-100">
                        <Table striped bordered hover size="sm" responsive>
                          <thead>
                            <tr>
                              <th>
                                <Form.Check
                                  type="checkbox"
                                  checked={
                                    resultadosBusca.length > 0 &&
                                    propostasSelecionadasDireta.length ===
                                      resultadosBusca.length
                                  }
                                  onChange={toggleSelecionarTodasDireta}
                                />
                              </th>
                              <th>GE</th>
                              <th>Proposta</th>
                              <th>Conta</th>
                              <th>C/V</th>
                              <th>Data Proposta</th>
                              <th>Fat.Op.</th>
                              <th>Valor Face</th>
                              <th>Valor Compra</th>
                              <th>Ef.</th>
                              <th>PM</th>
                              <th>Data Efetivação</th>
                              <th>Juros SFD</th>
                              <th>Tipo</th>
                              <th>Ativo</th>
                              <th>Usu. Digit.</th>
                              <th>Usu. Efet.</th>
                              <th>Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            {resultadosBuscaPagina.map(item => (
                              <tr key={item.codigo_proposta}>
                                <td>
                                  <Form.Check
                                    type="checkbox"
                                    checked={propostasSelecionadasDireta.includes(
                                      item.codigo_proposta
                                    )}
                                    onChange={() =>
                                      toggleSelecionarDireta(
                                        item.codigo_proposta
                                      )
                                    }
                                  />
                                </td>
                                <td>{item.codigo_grupo_empresa}</td>
                                <td>{item.codigo_proposta}</td>
                                <td>{item.codigo_conta}</td>
                                <td>{item.compra_venda}</td>
                                <td>{formatarData(item.data_proposta)}</td>
                                <td>{formatarMoeda(item.fato_rop)}</td>
                                <td>{formatarMoeda(item.valor_face)}</td>
                                <td>{formatarMoeda(item.valor_compra)}</td>
                                <td>{item.efetivac}</td>
                                <td>{item.prazo_medio}</td>
                                <td>{formatarData(item.data_efetivacao)}</td>
                                <td>{item.juros_sfd}</td>
                                <td>{item.tipo}</td>
                                <td>{item.codigo_ativo}</td>
                                <td>{item.usuario_digit}</td>
                                <td>{item.usuario_efet}</td>
                                <td>
                                  <Button
                                    variant="warning"
                                    onClick={() => {
                                      setPropostasSelecionadasDireta([
                                        item.codigo_proposta,
                                      ]);
                                    }}
                                  >
                                    Estornar
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                      {renderPaginacaoBuscaDireta()}
                    </>
                  )}

                  {propostasSelecionadasDireta.length > 0 && (
                    <Card className="mt-3 border-warning">
                      <Card.Body>
                        <h6>
                          Estornar{' '}
                          <strong>{propostasSelecionadasDireta.length}</strong>{' '}
                          proposta(s)
                        </h6>
                        <Form.Group>
                          <Form.Label className="small mb-1">
                            Justificativa (mínimo 11 caracteres)
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={justificativaDireta}
                            onChange={e =>
                              setJustificativaDireta(e.target.value)
                            }
                          />
                          {justificativaDireta.length > 0 &&
                            justificativaDireta.length < 11 && (
                              <small className="text-danger">
                                Justifique o motivo do estorno.
                              </small>
                            )}
                        </Form.Group>
                        <div className="mt-3">
                          <Button
                            variant="primary"
                            className="mr-2"
                            onClick={limparBuscaDireta}
                            disabled={estornandoDireta}
                          >
                            Cancelar
                          </Button>
                          <Button
                            variant="warning"
                            onClick={handleEstornarDireta}
                            disabled={
                              estornandoDireta ||
                              justificativaDireta.length < 11
                            }
                          >
                            {estornandoDireta ? (
                              <>
                                <Spinner
                                  animation="border"
                                  size="sm"
                                  className="mr-2"
                                />
                                Estornando...
                              </>
                            ) : (
                              'Confirmar Estorno'
                            )}
                          </Button>
                        </div>
                      </Card.Body>
                    </Card>
                  )}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </Container>
      )}

      {isLoading && (
        <div className="text-center mt-3">
          <Spinner
            animation="border"
            role="status"
            size="sm"
            className="mr-2"
          />
          Buscando solicitações de estorno de proposta...
        </div>
      )}
      {!isLoading && propostas.length === 0 && (
        <div className="text-center mt-3">Nenhuma solicitação encontrada</div>
      )}
      {propostas.length > 0 && (
        <Container>
          <div className="row mt-1">
            <div className="col-12">
              <div className="input-group input-focus">
                <input
                  type="search"
                  placeholder="Buscar proposta..."
                  className="form-control border-right-0"
                  onChange={e => setFiltroProposta(e.target.value)}
                />
                <div className="input-group-prepend">
                  <span className="input-group-text bg-white border-left-0">
                    <FaSearch />
                  </span>
                </div>
              </div>
            </div>
            <div className="text-muted ml-3 mt-1">
              {propostasFiltro.length > 0
                ? `Exibindo ${propostasFiltro.length} solicitações de estorno`
                : `Nenhuma solicitação encontrada`}
            </div>
          </div>
          <div className="row mt-2">
            {propostasFiltro.map((item, index) => (
              <div className="col-12" key={index}>
                <div
                  className={`mb-2 border-0 arrow-bottom-left proposta-${item.proposta} card`}
                >
                  {getColorStyle(item)}
                  <div
                    className="mx-3 my-1"
                    onClick={() => toggleExibirDetalhes(item)}
                  >
                    <ul className="list-unstyled d-flex mb-1">
                      <li>
                        <small className="d-block text-muted">Proposta</small>
                        <strong>{item.proposta}</strong>
                      </li>
                      <li className="mr-2 ml-auto">
                        <small className="d-block text-muted">Corretor</small>
                        <span>{item.corretor}</span>
                      </li>
                      <li>
                        <small className="d-block text-muted">
                          Imobiliária
                        </small>
                        <span
                          className="bullet"
                          style={{ backgroundColor: item.cor }}
                        ></span>
                        &nbsp;
                        {item.imobiliaria}
                      </li>
                    </ul>
                    <ul className="list-unstyled d-flex mb-1">
                      <li className="mr-2">
                        <small className="d-block text-muted">
                          Empreendimento
                        </small>
                        <strong>{item.empreendimento}</strong>
                      </li>
                      <li className="mr-2 ml-auto">
                        <small className="d-block text-muted">Quadra</small>
                        <strong>{item.quadra}</strong>
                      </li>
                      <li>
                        <small className="d-block text-muted">Lote</small>
                        <strong>{item.lote}</strong>
                      </li>
                    </ul>
                    <ul className="list-unstyled d-flex mb-0">
                      <li className="mr-2">
                        <small className="d-block text-muted">Cliente</small>
                        <span>{item.cliente}</span>
                      </li>
                      <li className="mr-2 ml-auto">
                        <small className="d-block text-muted">Conta</small>
                        <span>{item.codigo_conta}</span>
                      </li>
                      <li className="mr-2">
                        <small className="d-block text-muted">GE</small>
                        <span>{item.ge}</span>
                      </li>
                    </ul>
                  </div>

                  {exibeDetalhes === item.proposta && (
                    <>
                      <div className="item_detalhes-solicitacao mt-1 mb-2 py-3">
                        <div className="text-center">
                          <span className="text-muted">Justificativa</span>
                          <div className="row">
                            <div className="col-12">{item.justificativa}</div>
                          </div>
                        </div>
                        <hr className="doted" />
                        <div className="d-flex flex-column">
                          {exibeListaOcorrencia !== item.proposta && (
                            <>
                              <Ocorrencia
                                ocorrencia={item.ativo_ocorrencia[0]}
                                exibirDetalhes={
                                  exibeDetalheOcorrencia ===
                                  item.ativo_ocorrencia[0].data
                                }
                                onClick={() =>
                                  toggleExibirDetalhesOcorrencia(
                                    item.ativo_ocorrencia[0].data
                                  )
                                }
                              />

                              <button
                                type="button"
                                className="btn btn-outline-primary mx-auto mt-2"
                                onClick={() =>
                                  setExibeListaOcorrencia(item.proposta)
                                }
                              >
                                Ver mais ocorrências
                              </button>
                            </>
                          )}

                          {exibeListaOcorrencia === item.proposta &&
                            item.ativo_ocorrencia.map(
                              (itemOcorrencia, index) => (
                                <Ocorrencia
                                  ocorrencia={itemOcorrencia}
                                  key={index}
                                  exibirDetalhes={
                                    exibeDetalheOcorrencia ===
                                    itemOcorrencia.data
                                  }
                                  onClick={() =>
                                    toggleExibirDetalhesOcorrencia(
                                      itemOcorrencia.data
                                    )
                                  }
                                />
                              )
                            )}
                        </div>
                      </div>
                      {estornandoProposta && (
                        <div className="text-center mb-3">
                          <Spinner
                            animation="border"
                            role="status"
                            size="sm"
                            className="mr-2"
                          />
                          Estornando proposta...
                        </div>
                      )}

                      {!estornandoProposta &&
                        confirmaEstorno !== item.proposta && (
                          <div className="row mb-3 btn-center">
                            <Button
                              variant="warning"
                              className="btn-estornar"
                              onClick={() => setConfirmaEstorno(item.proposta)}
                            >
                              ESTORNAR
                            </Button>
                          </div>
                        )}

                      {!estornandoProposta &&
                        confirmaEstorno === item.proposta && (
                          <>
                            <div className="row  px-3">
                              <div className="col-12">
                                {item.revalida_ticket && (
                                  <div className="custom-control custom-checkbox">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input"
                                      id="chkRevalidarTicket"
                                      name="chkRevalidarTicket"
                                      onChange={e =>
                                        setRevalidaTicket(e.target.checked)
                                      }
                                    />
                                    <label
                                      className="custom-control-label"
                                      htmlFor="chkRevalidarTicket"
                                    >
                                      Revalidar ticket
                                    </label>
                                  </div>
                                )}
                                <div className="form-group">
                                  <label htmlFor="exampleFormControlTextarea1">
                                    Justificativa
                                  </label>
                                  <textarea
                                    className="form-control"
                                    id="exampleFormControlTextarea1"
                                    rows="3"
                                    onChange={e =>
                                      setJustificativa(e.target.value)
                                    }
                                    value={justificativa}
                                  />
                                  {justificativa.length < 11 && (
                                    <small className="feedback-text text-danger">
                                      Justifique o motivo do estorno.
                                    </small>
                                  )}
                                </div>
                                <div className="text-center">
                                  <span>
                                    Confirma estorno da proposta{' '}
                                    <strong>{item.proposta}</strong>?
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="row mb-3 btn-center">
                              <Button
                                variant="primary mr-4"
                                onClick={() => setConfirmaEstorno(null)}
                              >
                                CANCELAR
                              </Button>
                              <Button
                                variant="outline-primary"
                                disabled={justificativa.length < 11}
                                onClick={() => estornarProposta(item.proposta)}
                              >
                                CONFIRMAR
                              </Button>
                            </div>
                          </>
                        )}
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </Container>
      )}
    </div>
  );
}
